import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useToggle } from 'hooks/useToggle';
import { Settings } from '@material-ui/icons';
import RegularButton from 'components/CustomButtons/Button';
import { ModalV2 } from 'components/Modal/ModalV2';
import { FormStationConfigurationsEdit } from './FormStationConfigurations';

export const columns = [
    {
        Header: "Planta",
        accessor: "name",
        filterable: true,
        filterMethod: (filter, row) => row.name.toLowerCase().includes(filter.value.toLowerCase())
    },
    {
        Header: "Inv. Tanque",
        accessor: "show_digital_tanks",
        filterable: false,
        Cell: ({ original }) => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <FormControlLabel
                    control={<Checkbox
                        color='success'
                        checked={original?.show_digital_tanks}
                        size='small'
                        sx={{
                            color: 'rgb(246,110,94)',
                            '&.Mui-checked': {
                                color: 'rgb(98, 212, 102)',
                            },
                        }}
                    />}
                />
            </div>
        )
    },
    {
        Header: "Inv. AutoTanque",
        accessor: "show_digital_autotanks",
        filterable: false,
        Cell: ({ original }) => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <FormControlLabel
                    control={<Checkbox
                        color='success'
                        checked={original?.show_digital_autotanks}
                        size='small'
                        sx={{
                            color: 'rgb(246,110,94)',
                            '&.Mui-checked': {
                                color: 'rgb(98, 212, 102)',
                            },
                        }}
                    />}
                />
            </div>
        )
    },
    {
        Header: "Inv. Estación",
        accessor: "show_digital_stations",
        filterable: false,
        Cell: ({ original }) => (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <FormControlLabel
                    control={<Checkbox
                        color='success'
                        checked={original?.show_digital_stations}
                        size='small'
                        sx={{
                            color: 'rgb(246,110,94)',
                            '&.Mui-checked': {
                                color: 'rgb(98, 212, 102)',
                            },
                        }}
                    />}
                />
            </div>
        )
    },
    {
        Header: "Acciones",
        filterable: false,
        sortable: false,
        Cell: ({ original }) => {
            const [isOpenConfig, handleIsOpenConfig] = useToggle();

            return (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <RegularButton justIcon round color='transparent' tooltip="Configuracion" onClick={handleIsOpenConfig}>
                        <Settings style={{ color: '#4092E5' }} />
                    </RegularButton>

                    <ModalV2
                        open={isOpenConfig}
                        onClose={handleIsOpenConfig}
                        title="Configuración de Planta"
                        toRight
                    >
                        <FormStationConfigurationsEdit handleClose={handleIsOpenConfig} data={original} />
                    </ModalV2>
                </div>
            )
        },
    }
];